module.exports = __webpack_public_path__ + "img/11138_MUSTURD.90eadff1.webp";